export default __webpack_public_path__ + "static/media/33.fb89c83d.png";